/**
 * PUAマーカーの構造定数
 *
 * マーカーは「構造文字＋ID文字」の2文字で1マーカーを成す:
 *   [U+E000][IDx] 装飾対象 [U+E001][IDx]   ← 開始と終了は同じID文字
 *
 * 開始タグと終了タグは互いに独立した置換対象で、tokenize は領域マッチを使わない。
 * ID範囲は一度公開したら変更禁止（DB保存済み投稿の解釈が変わってしまう）。
 */

/** 開始マーカー。直後の1文字（idChar）がPUAコマンド種別を示す */
export const MARKER_OPEN = "\uE000"

/** 終了マーカー。直後の1文字（idChar）は対応する開始マーカーと同じIDであること */
export const MARKER_CLOSE = "\uE001"

/** 開閉ペア型PUAコマンドのID割り当て範囲（U+E100〜U+E1FF） */
export const PAIRED_ID_RANGE = { min: 0xe100, max: 0xe1ff } as const

/** 単独マーカー型のID割り当て範囲（U+E200〜U+E2FF）。枠組みのみ予約し、現時点で登録ゼロ */
export const STANDALONE_ID_RANGE = { min: 0xe200, max: 0xe2ff } as const
